import { createFileRoute } from '@tanstack/react-router'

import { ConnectedCardLoading } from '@/containers/connectedDebitCards/ConnectedCardLoading'
import { onDemandPayCardQueryOptions } from '@/queries/card'
import { orgInfoQueryOptions } from '@/queries/organization'
import { paymentProfileQueryOptions } from '@/queries/profile'
import { selectOrgData } from '@/selectors/organization'

export const Route = createFileRoute(
  '/_authenticated/account/_accountDetails/connectedDebitCards'
)({
  beforeLoad: () => ({
    title: 'Connected Debit Cards',
    breadCrumbTitle: 'Connected Debit Cards',
    subTitle: 'View and manage your connected debit cards.',
  }),
  pendingComponent: ConnectedCardLoading,
  loader: ({ context: { queryClient, orgStore } }) => {
    const data = queryClient.getQueryData(
      orgInfoQueryOptions(orgStore.getState().orgId).queryKey
    )
    const { directEwaEnabled } = selectOrgData(data)
    if (directEwaEnabled) {
      queryClient.ensureQueryData(onDemandPayCardQueryOptions())
    }
    return queryClient.ensureQueryData(paymentProfileQueryOptions)
  },
})
